<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-md-6">
      <div class="text-h6 q-mb-md">
        {{ $t('components.accountBillingTab.sections.creditsHistory') }}
      </div>

      <account-credits-history
        ref="account-credits-history"
        :doctor-id="account.userId"
        class="col-12 col-md-6"
      />
    </div>
  </div>
</template>

<script>
import AccountCreditsHistory from '@/components/AccountCreditsHistory';

export default {
  components: {
    AccountCreditsHistory,
  },
  props: {
    account: {
      type: Object,
      requried: true,
    },
  },
  created() {
    this.updateTitle();
  },
  methods: {
    updateTitle() {
      this.$emit(
        'update:title',
        this.$t('components.accountBillingTab.credits', {
          credits: this.$numeral(this.account.balance).format('0,0'),
        })
      );
    },
  },
};
</script>
